import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const PricingTable = () => {
  const [isAnnual, setIsAnnual] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="container mx-auto py-10 px-4">
      {/* Current Plan Display */}
      <div className="chosen-plan text-center mb-8">
        <span className="block text-gray-500">Your current plan:</span>
        <span className="plan-name text-lg font-bold text-blue-600">
          Starter Trial • 500 MAUs
        </span>
      </div>

      {/* Page Title */}
      <h1 className="page-title text-4xl font-bold text-center mb-8 bg-gradient-to-r from-blue-500 to-purple-500 text-transparent bg-clip-text" data-aos="fade-down">
        Choose a plan
      </h1>

      {/* Billing Type Toggle */}
      <div className="bill-type flex items-center justify-center mb-8 space-x-4" data-aos="fade-up">
        <span className="text-gray-500">Billed monthly</span>
        <div className="bill-toggle relative">
          <input
            type="checkbox"
            id="bill-toggle"
            checked={isAnnual}
            onChange={() => setIsAnnual(!isAnnual)}
            className="sr-only"
          />
          <label
            htmlFor="bill-toggle"
            className="block w-12 h-6 rounded-full bg-gray-300 cursor-pointer transition-colors duration-300 ease-in-out"
            style={{ backgroundColor: isAnnual ? '#4f46e5' : '#cbd5e1' }}
          >
            <span
              className={`block w-5 h-5 bg-white rounded-full shadow-md transform transition-transform duration-300 ease-in-out ${
                isAnnual ? 'translate-x-6' : 'translate-x-1'
              }`}
            />
          </label>
        </div>
        <span className="text-gray-500">Billed annually</span>
      </div>

      {/* Pricing Table */}
      <div className="pricing-table grid grid-cols-1 md:grid-cols-3 gap-8">
        {/* Starter Plan */}
        <div
          className="plan starter bg-gradient-to-b from-white to-gray-100 rounded-lg shadow-lg p-6 transition-transform transform hover:scale-105 hover:shadow-2xl relative overflow-hidden"
          data-aos="flip-up"
        >
          <h2 className="name text-2xl font-semibold text-gray-800 mb-4">Starter</h2>
          <div className="price text-3xl font-bold text-blue-600 mb-4">${isAnnual ? '15' : '19'}</div>
          <ul className="features list-disc pl-5 space-y-2 text-gray-700 mb-6">
            <li>500 MAUs</li>
            <li>3 projects</li>
            <li>Unlimited guides</li>
            <li>Unlimited flows</li>
            <li>Unlimited branded themes</li>
            <li>Email support</li>
          </ul>
          <button className="choose-btn w-full py-3 bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold rounded-lg hover:from-purple-500 hover:to-blue-500 transition duration-300">
            Choose Plan
          </button>
        </div>

        {/* Pro Plan */}
        <div
          className="plan pro bg-gradient-to-b from-white to-gray-100 rounded-lg shadow-lg p-6 transition-transform transform hover:scale-105 hover:shadow-2xl relative overflow-hidden"
          data-aos="flip-up"
        >
          <h2 className="name text-2xl font-semibold text-gray-800 mb-4">Pro</h2>
          <div className="price text-3xl font-bold text-blue-600 mb-4">
            ${isAnnual ? '79' : '99'} <sub className="text-lg">/ month</sub>
          </div>
          <div className="maus-options mb-4">
            <select className="border border-gray-300 rounded-md p-2 w-full">
              <option value="2500">2500 MAUs</option>
              <option value="5000">5000 MAUs</option>
              <option value="10000">10000 MAUs</option>
            </select>
            <span className="block text-gray-500 mt-2">Monthly active users</span>
          </div>
          <ul className="features list-disc pl-5 space-y-2 text-gray-700 mb-6">
            <li>All starter features, plus:</li>
            <li>Unlimited projects</li>
            <li>Unlimited fully customizable themes</li>
            <li>A dedicated customer success manager</li>
          </ul>
          <button className="choose-btn w-full py-3 bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold rounded-lg hover:from-purple-500 hover:to-blue-500 transition duration-300">
            Choose Plan
          </button>
        </div>

        {/* Enterprise Plan */}
        <div
          className="plan enterprise bg-gradient-to-b from-white to-gray-100 rounded-lg shadow-lg p-6 transition-transform transform hover:scale-105 hover:shadow-2xl relative overflow-hidden"
          data-aos="flip-up"
        >
          <h2 className="name text-2xl font-semibold text-gray-800 mb-4">Enterprise</h2>
          <div className="price text-3xl font-bold text-blue-600 mb-4">Let's talk!</div>
          <ul className="features list-disc pl-5 space-y-2 text-gray-700 mb-6">
            <li>All Pro features</li>
            <li>Unlimited MAUs</li>
            <li>Dedicated environment</li>
            <li>Premium support and services</li>
          </ul>
          <button className="choose-btn w-full py-3 bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold rounded-lg hover:from-purple-500 hover:to-blue-500 transition duration-300">
            Contact Us
          </button>
        </div>
      </div>
    </div>
  );
};

export default PricingTable;
